import React from "react";
import { string, number } from "prop-types";

const LinkedinIcon = ({ color = "#FFF", width = 19, height = 19 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 19 19">
    <path
      fill={color}
      fillRule="nonzero"
      d="M16.908.75c.339 0 .632.124.879.371.247.248.371.54.371.879v15c0 .339-.124.632-.371.879s-.54.371-.879.371h-15c-.338 0-.631-.124-.879-.371A1.201 1.201 0 0 1 .66 17V2c0-.339.123-.631.37-.879.248-.247.54-.371.88-.371h14.999zm-13.555 15h2.618V7.39H3.353v8.36zm1.29-9.492c.416 0 .774-.15 1.074-.45.3-.299.449-.65.449-1.054s-.15-.755-.45-1.055c-.299-.3-.657-.449-1.074-.449-.416 0-.768.15-1.054.45-.287.299-.43.65-.43 1.054s.143.755.43 1.055c.286.3.638.449 1.054.449zm11.015 9.492v-4.57c0-1.302-.182-2.253-.547-2.852-.495-.755-1.341-1.133-2.539-1.133a3.01 3.01 0 0 0-1.601.43c-.391.234-.678.534-.86.898h-.039V7.391h-2.5v8.359h2.578v-4.14c0-.652.091-1.146.274-1.485.26-.443.69-.664 1.289-.664s.99.247 1.172.742c.13.313.195.807.195 1.485v4.062h2.578z"
    />
  </svg>
);

LinkedinIcon.propTypes = {
  color: string,
  width: number,
  height: number
};

export default LinkedinIcon;
